// extracted by mini-css-extract-plugin
module.exports = {"project":"Project-module--project--6IUmO","name":"Project-module--name--2bHm3","overview":"Project-module--overview--csd6i","website":"Project-module--website--1cBwM"};